import { useRef, useState } from "react";
import { NotificationsLevel } from "../../../lib/enums";
import { show } from "../../../notifications/notifications";
import { TEST_CONNECTION_MAP } from "../../integrations/consts";

const INTEGRATIONS: Record<string, string> = {
  cape: "CAPE",
  cisco_secure_malware_analytics: "Cisco Secure Malware Analytics",
  cuckoo: "Cuckoo",
  fireeye: "Fireeye",
  joe: "Joe",
  vmray_tcbase: "VMRay"
};

const showConnectionError = (integration: string) => {
  show({
    level: NotificationsLevel.ERROR,
    message: `${INTEGRATIONS[integration]} integration is currently unavailable. Try again in a few minutes or check with your admin if the integration is correctly configured.`
  });
};

const useCheckIntegrations = () => {
  const [isLoading, setIsLoading] = useState(false);
  const abortControllers = useRef<Record<string, AbortController>>({});

  const checkIntegration = (integration: string) => {
    abortControllers.current?.[integration]?.abort();
    const abortController = new AbortController();
    abortControllers.current[integration] = abortController;
    return TEST_CONNECTION_MAP[integration]();
  };

  const checkIntegrations = async (integrations: Array<string>) => {
    setIsLoading(true);
    const selected = integrations.filter(
      integration => integration in INTEGRATIONS
    );
    const requests = selected.map(checkIntegration);
    const responses = await Promise.allSettled(requests);
    responses.forEach((response, index) => {
      if (response.status === "rejected") {
        showConnectionError(selected[index]);
      }
    });
    setIsLoading(false);
    return selected.reduce<Record<string, boolean>>(
      (acc, curr, index) => ({
        ...acc,
        [curr]: responses[index].status === "fulfilled"
      }),
      {}
    );
  };

  return { checkIntegrations, isLoading };
};

export default useCheckIntegrations;
